import { blankLinkTarget, LinkTargetFormValues } from './linkTarget'
import { seedProfiles } from './profileUtils'

/**
 * Shared "one link + a per-language label" row shape, reused by every admin
 * settings form that edits a manually-curated, ordered list of links —
 * Footer column links (`FooterColumnEditor`) and Navigation dropdown-item
 * links (`NavigationItemEditor`). Combines the 6-field `LinkTargetFormValues`
 * (see linkTarget.ts) with a stable `_key` (React/dnd identity, never sent to
 * the server) and a `profiles` array holding just the row's per-language
 * label.
 *
 * Blank-only — deliberately NO `mapLinkRowFromRaw`. Each caller's raw
 * profiles field is named differently server-side (Footer's
 * `footer_link_profiles`, Navigation dropdown's `profiles`), so mapping from
 * raw stays inline in each container's load effect rather than risking a
 * shared helper reading the wrong field and silently loading blank labels
 * (which, on these full-replace mutations, would then overwrite real
 * translations on the next Save).
 */
export type LinkRowProfileFormValues = {
  language: string
  label: string
}

export type LinkRowFormValues = LinkTargetFormValues & {
  /** Local-only stable id for React/dnd keys — never sent to the server. */
  _key: string
  profiles: LinkRowProfileFormValues[]
}

export function blankLinkRow(allLanguages: string[]): LinkRowFormValues {
  return {
    _key: crypto.randomUUID(),
    ...blankLinkTarget(),
    profiles: seedProfiles(undefined, allLanguages, lang => ({ language: lang, label: '' })),
  }
}
